import { AttachmentImageSize, EventLocationUseType, EventObserverActionUseType } from "../enums";
var EventSettingSimple = /** @class */ (function () {
    function EventSettingSimple(obj) {
        this.attachmentImageSize = obj && obj.attachmentImageSize || AttachmentImageSize.Large;
        this.observerActionUseType = obj && obj.observerActionUseType || EventObserverActionUseType.NotInUse;
        this.locationUseType = obj && obj.locationUseType || EventLocationUseType.NotInUse;
    }
    EventSettingSimple.prototype.observerActionIsInUse = function () {
        return this.observerActionUseType > EventObserverActionUseType.NotInUse;
    };
    ;
    EventSettingSimple.prototype.observerActionIsRequired = function () {
        return this.observerActionUseType > EventObserverActionUseType.InUse;
    };
    ;
    EventSettingSimple.prototype.locationIsInUse = function () {
        return this.locationUseType > EventLocationUseType.NotInUse;
    };
    ;
    return EventSettingSimple;
}());
export { EventSettingSimple };
